import { authActionsType, TOKEN_USER, CURRENT_USER, CURRENT_LANG, SCREEN_MODE } from '../../constants';
import { userService } from '../../services';
import { alertActions } from '../actions';

const login = (username = null, token = null) => {
    return dispatch => {
        userService.login(username, token)
            .then(
                response => { 
                    dispatch(success(response));
                },
                error => {
                    dispatch(failure(error));
                    dispatch(alertActions.error(error));
                });
            };
            
    function success(res) {
        localStorage.setItem(TOKEN_USER, res.data.token);
        localStorage.setItem(CURRENT_USER, JSON.stringify(res.data.user));
        return { type: authActionsType.LOGIN_SUCCESS, user: res.data }
    }
    function failure(error) { return { type: authActionsType.LOGIN_FAILURE, error } }
}

const logout = () => {
    return dispatch => {
        let lng = localStorage.getItem(CURRENT_LANG);
        let screenMode = localStorage.getItem(SCREEN_MODE);
        localStorage.clear();
        localStorage.setItem(CURRENT_LANG, lng);
        localStorage.setItem(SCREEN_MODE, screenMode)
        dispatch(signout());
    }
    function signout() { 
        return { type: authActionsType.LOGOUT } 
    }
}

export const authActions = {
    login,
    logout
};